import React, { useRef, useState } from 'react';
import { Avatar, Box, IconButton, InputBase, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser, setUser, updateUser } from '../../../reducers/auth/authSlice';
import { useUtils } from '../../../utils/useUtils';
import { ContentPaste, Upload } from '@mui/icons-material';
import { storage } from '../../../services/firebase';
import { useDispatch } from 'react-redux';

export default function PersonalDetails() {

  const [newImageURL, setNewImageURL] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const fileInput = useRef(null);

  const dispatch = useDispatch();
  const currentLoginUser = useSelector(selectUser);
  const { getCreatedDate, debounce } = useUtils();

  const copyToCliboard =  async(text) => {
    try{
      await navigator.clipboard.writeText(text);
    }catch(err){
      console.error(err);
    }
  };
 
  const handleImageUpload = (e) => {
    const file = e.target.files && e.target.files[0];
    if(!file) return;
    
    setIsLoading(true);

    const uploadTask = storage.ref(`images/${file.name}`).put(file);
    uploadTask.on(
      'state_changed',
      (snapshot) => {
        console.log('snapshot---->', snapshot);
      },
      (error) => {
        setIsLoading(false);
        console.error('Error uploading image:', error);
      },
      () => {
        storage
          .ref('images')
          .child(file.name)
          .getDownloadURL()
          .then((url) => {
            setNewImageURL(url);
            updateUserProfile({ photoURL: url});
            setIsLoading(false);
          });
      }
    );
  };

  const updateUserProfile = async(doc) => {
    try {
      await dispatch(updateUser(currentLoginUser._id, doc));

      dispatch(setUser({
        ...currentLoginUser,
        ...doc
      }));
    }catch(err){
      console.error(err);
    }
  };


  const updateName = (e) => {
    const handleTypingFinished = debounce(async() => {
      try{
        updateUserProfile({ name: e.target.value });
      }catch(err){
        console.error(err);
      }
    }, 1000);
    
    handleTypingFinished();
  };

  const updatePhoneNumber = (e) => {
    const handleTypingFinished = debounce(async() => {
      try{
        updateUserProfile({ phoneNumber: e.target.value });
      }catch(err){
        console.error(err);
      }
    }, 1000);
    
    handleTypingFinished();
  };

  const openFile = () => {
    fileInput && fileInput.current.click();
  };

  return (
    <>
      <Typography variant='h6'>Personal Information</Typography>

      <Box display={'flex'} alignItems={'center'} columnGap={2} my={1}>
        <Avatar
          alt={currentLoginUser.name} 
          src={newImageURL || currentLoginUser.photoURL}
        />

        <input 
          style={{ position: 'absolute', visibility:'hidden' }} 
          ref={fileInput}
          type='file'
          accept="image/*"
          onChange={e => handleImageUpload(e)}
        />

        <IconButton disabled={isLoading} onClick={openFile}>
          <Upload />
        </IconButton>
        
      </Box>


      <Box display={'flex'} flexDirection={'column'} rowGap={2}>

        <Box display={'flex'} alignItems={'center'} columnGap={8}>
          <Typography variant='body2' color={'#656f7d'}>Display Name</Typography>
  
          <InputBase 
            defaultValue={currentLoginUser.name} 
            sx={{ fontSize: 14, mt: 0.5}} 
            size='small' 
            onChange={updateName}
          />
        </Box>


        <Box display={'flex'} alignItems={'center'} columnGap={14.7}>
          <Typography variant='body2' color={'#656f7d'}>Email</Typography>
  
          <Typography sx={{ color: '#960000'}} variant='body2'>
            {currentLoginUser.email}

            <IconButton size='small' onClick={() => copyToCliboard(currentLoginUser.email)}>
              <ContentPaste sx={{ fontSize: 15 }} />
            </IconButton>
          </Typography>
        </Box>



        <Box display={'flex'} alignItems={'center'} columnGap={10}>
          <Typography variant='body2' color={'#656f7d'}>Joined Date</Typography>
 
          <Typography variant='body2'>{getCreatedDate(currentLoginUser.createdAt)}</Typography>
        </Box>

        <Box display={'flex'} alignItems={'center'} columnGap={7.5}>
          <Typography variant='body2' color={'#656f7d'}>Phone Number</Typography>
  
          <InputBase 
            defaultValue={currentLoginUser.phoneNumber || '+88 0'} 
            sx={{ fontSize: 14, mt: 0.5}} 
            size='small'
            onChange={updatePhoneNumber}
          />
        </Box>

        <Box display={'flex'} alignItems={'center'} columnGap={13.5}>
          <Typography variant='body2' color={'#656f7d'}>User ID</Typography>
  
          <Typography variant='body2'>
            {currentLoginUser.uid}

            <IconButton size='small' onClick={() => copyToCliboard(currentLoginUser.uid)}>
              <ContentPaste sx={{ fontSize: 15 }} />
            </IconButton>
          </Typography>
        </Box>

      </Box>
    </>
  );
}
